module.exports = __webpack_public_path__ + "fondo-blanco.b2f4f5d88712bdd0913c.png";


//////////////////
// WEBPACK FOOTER
// /Users/diego/Documents/SirisWebSite/WebSite/src/assets/images/fondo-blanco.png
// module id = ../../../../../src/assets/images/fondo-blanco.png
// module chunks = styles